import { useEffect, useState } from 'react';

import { useDrawingManagerContext } from '../context/drawing-manager-context.js';

import type { DrawingElement } from '@cadstrom/renderer';

export function HoverState() {
	const { drawingManager } = useDrawingManagerContext();
	const [hover, setHover] = useState<DrawingElement[]>([]);

	useEffect(() => {
		if (!drawingManager) {
			return;
		}

		function hoverStateChanged(element: DrawingElement) {
			if (element.isHovered && element.isVisible) {
				setHover((h) => {
					const hasElement = hover.includes(element);
					if (!hasElement) {
						return [element, ...h];
					}

					return h;
				});
			} else {
				setHover((h) => h.filter((e) => e !== element));
			}
		}

		drawingManager.on('elementHoverStateChanged', hoverStateChanged);
		return () => {
			drawingManager.removeListener('elementHoverStateChanged', hoverStateChanged);
		};
	}, [drawingManager, hover]);

	const getSelection = () =>
		hover
			.map((h) => {
				for (const prop of h.getProperties()) {
					for (const [propName, props] of Object.entries(prop)) {
						return (Array.isArray(props) ? props : [props]).join(', ');
					}
				}

				return undefined;
			})
			.filter((h) => Boolean(h))
			.join(', ');

	if (hover.length === 0) {
		return <div />; // Empty div to maintain the space in the grid
	}

	return <p className='truncate min-w-0 text-sm'>({getSelection()})</p>;
}
